module.exports = __webpack_public_path__ + "media/images/site/fundamental1_calcada-f437346b2c9eea7bd8f38b0ef1f3b4ee.jpg";